import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import * as moment from 'moment';

import { EventTypes } from '../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';

import { TransactionHistoryService } from '../transaction-history.service';

import { Auth } from '../../../autentication/Auth';
import { AutenticationEventType } from '../../../autentication/autentication.event.type';
import { TransactionHistoryEventType } from '../transaction-history.event.type';

import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { Transaction } from '../models/transaction';

@Component({
	selector: 'app-transaction-pending',
	templateUrl: './transaction-pending.component.html',
	styleUrls: ['./transaction-pending.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransactionPendingComponent implements OnInit, OnDestroy {

	view = '[data-component="transaction-pending"]';
	viewHeight = 0;
	active = false;
	pendingList: Array<Transaction> = [];
	@Input() transactionUser: boolean;
	@Output() canSend: EventEmitter<boolean> = new EventEmitter();
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(private service: TransactionHistoryService) { }

	ngOnDestroy() {
		this.removeListeners();
	}

	removeListeners() {
		AppEventDispatcher.removeListener(TransactionHistoryEventType.HISTORY.TRANSACT);
		AppEventDispatcher.removeListener(TransactionHistoryEventType.TRANSACTION_HISTORY_SEND);
		AppEventDispatcher.removeListener(TransactionHistoryEventType.HISTORY.HIDE_PENDING_TRANSACTIONS);
		AppEventDispatcher.removeListener(TransactionHistoryEventType.HISTORY.SHOW_ALL_TRANSACTIONS);
	}

	ngOnInit() {
		AppEventDispatcher.listen(TransactionHistoryEventType.HISTORY.TRANSACT, () => {
			this.active = true;
			this.load();

			this.showStepButtons.emit(true);
		});

		AppEventDispatcher.listen(TransactionHistoryEventType.HISTORY.SHOW_ALL_TRANSACTIONS, () => {
			this.show();
		});

		AppEventDispatcher.listen(TransactionHistoryEventType.HISTORY.HIDE_PENDING_TRANSACTIONS, () => {
			this.removeListeners();
			TweenMax.to(this.view, .8, {delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});
	}

	load() {
		this.preload(true);

		this.service.getTransactions('pendente').subscribe( data => {
			this.pendingList = data;
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.LAST_TRANSACTIONS, { show: true });
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.SCHEDULED_TRANSACTIONS, { show: true });
			this.setSendListener();

		}, error => {
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.LAST_TRANSACTIONS, { show: true });
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.SCHEDULED_TRANSACTIONS, { show: true });
		});
	}

	setSendListener() {
		if (this.pendingList.length !== 0) {
			AppEventDispatcher.listen(TransactionHistoryEventType.TRANSACTION_HISTORY_SEND, () => {
				this.hide();
			});
		}
	}

	show() {
		this.preload(false);
		const interval = setInterval(() => {
			if ($(this.view).length > 0) {
				TweenMax.to(this.view, .8, {delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, left: 0, ease: Quint.easeOut});
				clearInterval(interval);
			}
		}, 10);
	}

	hide() {
		this.removeListeners();
		const list: Array<Transaction> = this.pendingList.filter( (item) => {
			item.details = new Array<ListItem>();

			return item.status.toLowerCase() !== 'pendente' ? true : false;
		});

		if (list.length > 0) {

			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.RESUME, { show: true, list: list });
			AppEventDispatcher.dispatch(TransactionHistoryEventType.BUTTONS_CONFIRM, { show: true });
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.HIDE_LAST_TRANSACTIONS, { show: false });
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.HIDE_SCHEDULED_TRANSACTIONS, { show: false });

			TweenMax.to(this.view, .8, {delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});

		} else {
			this.setSendListener();
		}
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="transaction-history"] .content', show: active, delay: delay});
	}

	openDetails(event: any, index: number) {
		if (this.pendingList[index].details.length === 0) {
			if (this.pendingList[index].typeTransaction === 'Pacotes') {
				this.getDetailsPackages(index);
			} else {
				this.getDetailsTransaction(index);
			}
		} else {
			this.animateDetails(index);
		}
	}

	getDetailsTransaction(index: number) {
		this.pendingList[index].loading = true;

		this.service.getDetails(this.pendingList[index]).subscribe( data => {
			this.pendingList[index].details = data;
			this.pendingList[index].loading = false;

			this.animateDetails(index);

		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.pendingList[index].loading = false;
		});
	}

	getDetailsPackages(index: number) {
		this.pendingList[index].loading = true;

		this.service.getDetailsPackages(this.pendingList[index]).subscribe( data => {
			this.pendingList[index].details = data;
			this.pendingList[index].loading = false;
			this.animateDetails(index);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.pendingList[index].loading = false;
		});
	}

	animateDetails(index) {

		const interval = setInterval(() => {

			if ($(`#detail-${index}`).prop('checked')) {
				const h = $(`#detail-${index} + .details`).find('[data-component="list-confirmation"]').outerHeight();
				TweenMax.to(`#detail-${index} + .details`, .8, {height: h, ease: Quint.easeOut});
				TweenMax.to($(`[for="detail-${index}"]`).find('.icon'), .4, {rotation: 90, ease: Quint.easeOut});
			} else {
				TweenMax.to(`#detail-${index} + .details`, .6, {height: 0, ease: Quint.easeOut});
				TweenMax.to($(`[for="detail-${index}"]`).find('.icon'), .4, {rotation: 0, ease: Quint.easeOut});
			}

			clearInterval(interval);

		}, 10);
	}

	changeStatus(status, index) {
		this.pendingList[index].status = status;

		if (status === 'Aprovar') {
			this.pendingList[index].statusCode = 1;
		} else if (status === 'Reprovar') {
			this.pendingList[index].statusCode = 2;
		} else if (status === 'Cancelar') {
			this.pendingList[index].statusCode = 3;
		} else {
			this.pendingList[index].statusCode = 4;
		}

		const list: Array<Transaction> = this.pendingList.filter( (item) => {
			return item.status.toLowerCase() !== 'pendente' ? true : false;
		});

		if (list.length > 0) {
			this.canSend.emit(true);
		} else {
			this.canSend.emit(false);
		}

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transaction-history/transaction-pending/transaction-pending.component.ts